export const ARTICLE_TYPE = {
  NEWS: 'NEWS',
  CASE_STUDIES: 'CASE-STUDIES',
  BLOG: 'BLOG',
  EVENT: 'EVENT',
};

export const REFERENCE_SECTION_NAMES = {
  BLOG: 'Blogs',
  NEWS: 'News',
  CASE_STUDIES: 'Case Studies',
  EVENT: 'Events',
};

// News
export const ARTICLE_NEWS_REFERENCE_CATEGORIES = {
  CATEGORY: 'Categories',
  SUB_CATEGORY: 'Sub-categories',
  TAGS: 'Tags',
};

export const ARTICLE_NEWS_REFERENCE_CATEGORIES_KEYS = {
  NAME: 'Name',
  SLUG: 'Slug',
};

export const ARTICLE_NEWS_REFERENCE_SUB_CATEGORIES_KEYS = {
  NAME: 'Name',
  SLUG: 'Slug',
  PARENT_CATEGORY: 'Parent Category',
};

export const ARTICLE_NEWS_REFERENCE_TAGS_KEYS = {
  NAME: 'Name',
  SLUG: 'Slug',
};

// Blogs
export const ARTICLE_BLOG_REFERENCE_CATEGORIES_KEYS = {
  NAME: 'Name',
  SLUG: 'Slug',
};

export const ARTICLE_BLOG_REFERENCE_SUB_CATEGORIES_KEYS = {
  NAME: 'Name',
  SLUG: 'Slug',
  PARENT_CATEGORY: 'Parent Category',
};

export const ARTICLE_BLOG_REFERENCE_TAGS_KEYS = {
  NAME: 'Name',
  SLUG: 'Slug',
};

// Case Studies
export const ARTICLE_CASE_STUDIES_REFERENCE_CATEGORIES_KEYS = {
  NAME: 'Name',
  SLUG: 'Slug',
};

export const ARTICLE_CASE_STUDIES_REFERENCE_SUB_CATEGORIES_KEYS = {
  NAME: 'Name',
  SLUG: 'Slug',
  PARENT_CATEGORY: 'Parent Category',
};

export const ARTICLE_CASE_STUDIES_REFERENCE_TAGS_KEYS = {
  NAME: 'Name',
  SLUG: 'Slug',
};

export const ARTICLE_STATUSES = {
  DRAFT: 'Draft',
  RETURNED: 'Returned',
  IN_REVIEW: 'In Review',
  DELETED: 'Deleted',
  PUBLISHED: 'Published',
  SCHEDULED: 'Scheduled',
  RESTORE: 'Restore',
};

export enum FILETYPE {
  IMAGE = 'IMAGE',
  AUDIO = 'AUDIO',
}

export enum NEWS_REFERENCE_CATAGORIES {
  CATEGORIES = 'Categories',
  SUB_CATEGORIES = 'Sub_Categories',
  TAGS = 'Tags',
}
